// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6a3c32f8","239":"2a9aab4b","455":"4cec9282"}[chunkId] + ".chunk.js";
};